import { parseDate } from '@bonlineza/b-lib/functions';

export default (data) => parseDate(data, 'DD/MM/YYYY');
